import {FilterCategoryDefinitionBase} from "./filter-category-definition-base";
import {IGameFilterDefinition} from "../filters-definitions/game-filter-definition.interface";
import {HighVolatilityFilterDefinition} from "../filters-definitions/volatility/high-volatility.filter-definition";
import {LowVolatilityFilterDefinition} from "../filters-definitions/volatility/low-volatility.filter-definition";
import {MediumVolatilityFilterDefinition} from "../filters-definitions/volatility/medium-volatility.filter-definition";
import {CategoryDefinitionId} from "./filter-category-definition.interface";

export class VolatilityFiltersCategoryDefinition extends FilterCategoryDefinitionBase {
    get id(): CategoryDefinitionId {
        return 'volatility';
    }

    get title(): string{
        return this.services.translation.translate('VOLATILITY');
    }
    protected _loadAvailableFilters(): IGameFilterDefinition[] {
        return [
            new LowVolatilityFilterDefinition(this.services),
            new MediumVolatilityFilterDefinition(this.services),
            new HighVolatilityFilterDefinition(this.services)
        ];
    }

    get isMultiSelect(): boolean {
        return false;
    }
}